import React from 'react';
import { useQuery, useAppAndBranchId } from '../../../hooks';
import { api } from '../api';
import { useParams } from 'react-router-dom';
import { CreateDialog } from '../createDialog';

export function EditDialog() {
	const { dialogId } = useParams();
	const [appId, branchId] = useAppAndBranchId();
	const { data: dialogGroups, loading } = useQuery(() =>
		api.getDialogs(appId, branchId),
	);

	const dialog = dialogGroups
		?.map((dialog) => {
			return dialog.dialogGroups.map((el) => ({
				...el,
				dialogType: dialog.dialogType,
				dialogValue: dialog.dialogValue,
			}));
		})
		.flat()
		.find((dialog) => dialog?.id === dialogId);

	if (loading) {
		return <p />;
	}

	if (!loading && !dialog) {
		return <p>The dialog is not found</p>;
	}

	return <CreateDialog dialog={mapDialogToState(dialog)} />;
}

const mapDialogToState = (dialog: any): any => {
	let { isServiceEnabled, id, hasImage, messageCount, order, ...newDialog } =
		dialog;
	if (!newDialog.messages) {
		newDialog.messages = [];
	}
	if (!newDialog.suggestions) {
		newDialog.suggestions = [];
	}
	if (!newDialog.actions) {
		newDialog.actions = {};
	}
	Object.entries(newDialog.actions).forEach(([key, value]: any) => {
		const { isServiceEnabled, hasImage, messageCount, isRandom, ...rest } =
			value;
		if (rest.type === 'message') {
			delete rest.flowName;
			delete rest.nodeId;
		}
		newDialog.actions[key] = rest;
	});
	return newDialog;
};
